export default "__VITE_ASSET__dbDVsRyB__"